import { createLogger, toBanner } from '@lglp/prismic-client';

import { compact, unprefix } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { HubActus } from '../../../../types/page/hub-actus';
import { processSlices } from '../../slices';
import hubSlice from '../../slices/hub/hub';
import { pageEntity } from './internal';

const processHubActus = (entity: any): HubActus => {
  const { logger } = createLogger();
  return compact({
    uid: DocumentType.HUB_ACTUS,
    type: DocumentType.HUB_ACTUS,
    banner: toBanner(unprefix('header', entity.data), logger),
    body: processSlices(
      {
        hub: hubSlice(DocumentType.HUB_ACTUS),
      },
      entity.data?.body_slices
    ),
  });
};

export const HubActualitesEntity = pageEntity<HubActus>(
  DocumentType.HUB_ACTUS,
  {
    processStrategy: processHubActus,
  }
);
